<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-adiantamentos') {
            next({ name: 'des-adiantamentos-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-adiantamentos') {
            this.$router.push({ name: 'des-adiantamentos-list' });
        }
    },
};
</script>
